var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON/Journal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.566 25.9916H4.56902C2.59467 25.9916 1 24.3969 1 22.4225V3.37935C1 2.06311 2.06311 1 3.37935 1H23.7725C25.0888 1 26.1519 2.06311 26.1519 3.37935V22.4141C26.1519 24.3885 24.5488 26 22.566 26V25.9916Z",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 59",
    x: 5.99219,
    y: 1.33545,
    width: 3.57143,
    height: 16.6667,
    fill: "#102D3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M22.6602 1.33545V25.7402",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    d: "M19.0898 1.33545V25.7402",
    stroke: "#102D3E",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournal);
export default __webpack_public_path__ + "static/media/Journal.d74cf33240cd42af2928bbfeb46c8377.svg";
export { ForwardRef as ReactComponent };